import { useEffect, useState, useMemo } from "react";
import * as React from "react";
import flat from "flat";
// eslint-disable-next-line no-restricted-imports
import { IntlProvider } from "react-intl";
import { useParams, useLocation, matchRoutes } from "react-router-dom";
import en from "../locale/en_US.json";
import LocalCookie, { CookieKey } from "../util/LocalCookie";
// import { LocaleSelector } from 'store/data/Base'
// import { useSetRecoilState } from 'recoil'
import Loading from "components/common/Loading";
import { localMap } from "../constants/base";
import { GlobalRouterConfig } from "screens/GlobalRouterConfig";
import { LocaleSelector } from "store/data/Base";
import { useRecoilState } from "recoil";
import { useIntlCacheInClient } from "@app/utils/IntlSSRCache";
import { localeTransform } from "util/utils";
import commonEn from "locale/common/en_US.json";

const flatedEn = flat({ ...en, ...commonEn });

function IntlProviderWithRecoil(props: { children?: React.ReactNode }) {
  const { pathname } = useLocation();
  const [locales, setLocales] = useRecoilState(LocaleSelector);
  const [message, setMessage] = useState<{
    [key: string]: { [key: string]: string };
  }>({
    en: flatedEn,
    "en-GB": flatedEn,
    "en-PH": flatedEn,
    "en-IN": flatedEn,
    "en-ZA": flatedEn,
  });

  useEffect(() => {
    let mathRoute: any = null;
    try {
      const result = matchRoutes(GlobalRouterConfig, pathname);
      // console.log('result', result, mathRoute?.params?.locales, pathname)
      if (result && result.length && !pathname.includes("/mix/")) {
        mathRoute = result[0];

        const { params } = mathRoute;
        if (params?.locales) {
          setLocales(params?.locales || "en");
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [locales, pathname, setLocales]);

  useEffect(() => {
    async function fetchLocale() {
      try {
        const json = await import(
          /* webpackChunkName: "[request]" */ `../locale/${localMap[locales]}.json`
        );
        setMessage((state) => {
          if (!Object.prototype.hasOwnProperty.call(state, locales)) {
            return { ...state, [locales]: flat(json) };
          }
          return state;
        });
      } catch (e) {
        setMessage((state) => {
          if (!Object.prototype.hasOwnProperty.call(state, locales)) {
            return { ...state, [locales]: flatedEn };
          }
          return state;
        });
      }
    }
    if (!Object.prototype.hasOwnProperty.call(message, locales)) fetchLocale();
  }, [locales, message]);

  const chilrenApp = useMemo(
    () => props.children,
    [props.children, message[locales], pathname]
  );

  return (
    <IntlProvider
      locale={localeTransform(locales)}
      defaultLocale="en"
      messages={message[locales]}
      key={locales}
      onError={(error) => {
        // TODO 临时屏蔽
        // const logError = String(error).match(/Missing message.*,/)?.[0]
        // console.log('%c' + logError, 'color:blue')
      }}
    >
      {/* {message[locales] ? props.children : <Loading size="big" />} */}
      {chilrenApp}
    </IntlProvider>
  );
}

export default IntlProviderWithRecoil;
